import PremiumLayout from "../../components/[city]/_premiumLayout";
import { GetCityName } from "../../hook/GetCityName";

export default function MapaStronyLayout() {
  const [CityName] = GetCityName();

  let Miasto = CityName;

  return <PremiumLayout Miasto={Miasto} Podatek="mapastrony" />;
}
